import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

import Rent from "../../../../../Assets/Images//rent.jpg";
import { useStyles } from "./ErrorMessage.css";

class ErrorMessage extends Component {
  render() {
    const { classes, message, bookId } = this.props;
    return (
      <div
        className={classes.root}
        style={{
          backgroundImage: `url(${Rent})`,
        }}
      >
        {this.props.type === "expired" ? (
          <Fragment>
            <div className={classes.messageStyle} style={{ fontSize: 50 }}>
              {message}
            </div>
            <Link to={`/books/details/${bookId}`} className={classes.link}>
              Go to Book Store.
            </Link>
          </Fragment>
        ) : (
          <Fragment>
            <div className={classes.messageStyle}>{message}</div>
            <Link to="/books" className={classes.link}>
              Go to Book Store.
            </Link>
          </Fragment>
        )}
      </div>
    );
  }
}

export default withStyles(useStyles)(ErrorMessage);
